module.exports = __webpack_public_path__ + "static/img/video_vrroad.b2aa3ebf.png";